import { redirect } from 'react-router-dom';

/**
 * The public Demo runs on its own App host (`demo.streamlain.de`, locally
 * `demo.localhost:<port>`). Visitors there have no StreamLain account, so the
 * Demo entry `/demo` replaces the sign-in page on that host.
 */
export const DEMO_ENTRY_PATH = '/demo';

export function isDemoAppHostname(
  hostname = typeof location === 'undefined' ? '' : location.hostname
): boolean {
  return hostname.toLowerCase().split('.')[0] === 'demo';
}

/** Loader for every sign-in route: Demo host visitors go to the Demo entry. */
export function demoHostSignInLoader() {
  return isDemoAppHostname() ? redirect(DEMO_ENTRY_PATH) : null;
}
